import { createVueComponent } from '../../functions/create-vue-component';
import component from './component.vue';

export function createBookingCustomRental(elementId, props) {
    createVueComponent({ elementId, component, props });
}